import callWebGate from './callWebGate';

import queryString from 'query-string';

import { SORT_FIELDS } from 'mappers/sort';

export function AdNotFoundError(message) {
  this.name = 'AdNotFoundError';
  this.message = message;
}

AdNotFoundError.prototype = Object.create(Error.prototype);

export function getAds(offset, limit, wgToken) {
  const url = `adgenerator/v1/ads?limit=${limit}&offset=${offset}`;
  return callWebGate(url, wgToken)
    .then(r => {
      if (!r.ok) return Promise.reject(r.statusText);
      return r.json();
    });
}

export function refreshAds(params, wgToken, webGate = callWebGate) {
  const url = getAdsUrl(params);
  return webGate(url, wgToken)
    .then(r => {
      if (!r.ok) return Promise.reject(r.statusText);
      return r.json();
    });
}

function getAdsUrl(params) {
  const {
    limit = 20,
    offset = 0,
    orderBy,
    order = 'asc',
    status,
    searchWord,
  } = params;
  const sortField = SORT_FIELDS[orderBy];
  const queryParams = queryString.stringify({
    limit,
    offset,
    orderBy: sortField,
    order,
    status: status || undefined,
    searchWord: searchWord || undefined,
  });
  const url = `adgenerator/v1/ads?${queryParams}`;
  return url;
}

export function getAd(id, wgToken, webGate = callWebGate) {
  const url = `adgenerator/v1/ads/${id}`;
  return webGate(url, wgToken)
    .then(r => {
      if (r.status === 404) {
        return Promise.reject(new AdNotFoundError(r.statusText));
      }
      if (!r.ok) return Promise.reject(new Error(r.statusText));
      return r.json();
    });
}

export function approveAd(id, wgToken) {
  const url = `adgenerator/v2/ads/${id}/approve`;
  const opts = { method: 'POST' };

  return callWebGate(url, wgToken, opts)
    .then(r => {
      if (!r.ok) return Promise.reject(r.statusText);
      return r;
    });
}

export function rejectAd(id, reason, wgToken) {
  const url = `adgenerator/v1/ads/${id}/reject`;
  const opts = Object.assign({
    method: 'POST',
    body: JSON.stringify({
      reason: reason,
    }),
  });

  return callWebGate(url, wgToken, opts)
    .then(r => {
      if (!r.ok) return Promise.reject(r.statusText);
      return r;
    });
}

export function reviseVO(id, reviseVOInstructions, wgToken) {
  const url = `adgenerator/v1/ads/${id}/audio/revise-vo`;
  const opts = {
    method: 'POST',
    body: JSON.stringify({
      reviseVOInstructions,
    }),
  };

  return callWebGate(url, wgToken, opts)
    .then(r => {
      if (!r.ok) return Promise.reject(r.statusText);
      return r;
    });
}

export function reviseBGMusic(id, bgAssetId, wgToken) {
  const url = `adgenerator/v1/ads/${id}/audio/revise-bg`;
  const opts = {
    method: 'POST',
    body: JSON.stringify({
      bgAssetId,
    }),
  };

  return callWebGate(url, wgToken, opts)
    .then(r => {
      if (!r.ok) return Promise.reject(r.statusText);
      return r;
    });
}


export function cancelAd(id, wgToken, webGate = callWebGate) {
  const url = `adgenerator/v1/ads/${id}/cancel`;
  const opts = { method: 'POST' };

  return webGate(url, wgToken, opts)
    .then(r => {
      if (!r.ok) return Promise.reject(r.statusText);
      return r;
    });
}

export function kickAd(id, wgToken, webGate = callWebGate) {
  const url = `adgenerator/v1/ads/${id}/kick`;
  const opts = { method: 'POST' };

  return webGate(url, wgToken, opts)
    .then(r => {
      if (!r.ok) return Promise.reject(r.statusText);
      return r;
    });
}



// WEBPACK FOOTER //
// ./src/api/ads.js